import { useQuery } from "@tanstack/react-query";
import { ApiGetMyFortAgents } from "@/api";
import { FORT_AGENT_STATUS, MyFortAgentItem } from "@/api/types";
import { useUserStore } from "@/store/useUserStore";

/** 已激活排最前，其余保持原顺序 */
function sortAgents(agents: MyFortAgentItem[]): MyFortAgentItem[] {
  return [...agents].sort((a, b) => {
    const aActivated = a.status === FORT_AGENT_STATUS.ACTIVATED ? 0 : 1;
    const bActivated = b.status === FORT_AGENT_STATUS.ACTIVATED ? 0 : 1;
    return aActivated - bActivated;
  });
}

export function useGetMyFortAgents() {
  const { userInfo } = useUserStore();
  return useQuery({
    queryKey: ["myFortAgents"],
    queryFn: async () => {
      const res = await ApiGetMyFortAgents();
      console.log("useGetMyFortAgents", res.data);
      return res.data;
    },
    select: data => ({
      ...data,
      agents: sortAgents(data.agents),
    }),
    enabled: !!userInfo?.address,
    refetchInterval: 3000,
  });
}
